import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { TagsService } from 'src/app/services/tags/tags.service';
import { StorageService } from "src/app/services/storage/storage.service";
import { environment } from "src/environments/environment";
import { CredentialsService } from "src/app/services/credentials/credentials.service";
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { RouterService } from 'src/app/services/router/router.service';

@Component({
  selector: 'app-challenges',
  templateUrl: './challenges.page.html',
  styleUrls: ['./challenges.page.scss'],
})
export class ChallengesPage implements OnInit {
  token: any;
  appId: any;
  isStrapi = false;
  constructor(private router: Router,
    public languageService: LanguagesService,
    private tagsService:TagsService,
    private storageService: StorageService,
    private platform: Platform,
    private credentialsService: CredentialsService,
    private remoteConfig: RemoteConfigService,
    private routerService: RouterService) { }

  async ngOnInit() {
   //  this.tagsService.setEventTag('challenge_page','challenge_screen_viewed');
     this.remoteConfig.getIsStrapi().subscribe((res) => {
       this.isStrapi = res;
     });
     this.token = await this.storageService.get("gnx-token");
     this.appId = environment.gluky.apikey;
     console.log("ngOnInit() challenges");

     window.addEventListener("challengeStatus", function (event: any) {
      console.log("event", event);
    });
  }

  doRefresh(event) {
    console.log('Begin async operation');
    location.reload();

    setTimeout(() => {
      console.log('Async operation has ended');
      event.target.complete();
    }, 2000);
  }

  getCredentialsChallenges = async () => {
    return await this.credentialsService.challengesStrapi();
  };
  
  getCredentialsChallengesPrefix = async () => {
    // return await this.contentService.getSignature();
  };

  async ionViewDidEnter() {
    let challengesWc: any = document.querySelector("gnx-challenges-list");
    await challengesWc.callStrapiInfo();
  }


  refreshPage(events){
    console.log("evnet", events);
  }

  public viewMore({ detail: { id, type } }) {
    console.log(id, type);
    this.tagsService.setEventTag('challenge_page','challenge_category_clicked');
    this.router.navigate(['app', 'challenges', 'detail', type, id]);
  }

  public toBack() {
    this.router.navigate(['app','content'], {replaceUrl: true});
  }

  get getTextsIUPageChallenges() {
    return this.languageService.textsIU.page_challenges;
  }

  goPrev(){
    this.routerService.redirectRoot("/app/content");
  }

}